import React, { useEffect } from 'react';
import { UserProvider } from "./context/UserContext";
import { PopupProvider } from "./context/PopupContext";
import { BrowserRouter as Router, Route } from "react-router-dom";
import Payment from "./pages/main/payment";
import BC365Service from "./services/beautyclub365";

function App() {
    useEffect(() => {
        const db = new BC365Service();
        let res = db.fixAnalytic();

        if (new URLSearchParams(window.location.search).get('from_webinar') === 'Y')
            db.setFromWebinar();

    }, []);

  return (
    <UserProvider>
      <PopupProvider>
        <Router>
          <Route path="/">
            <Payment />
          </Route>
        </Router>
      </PopupProvider>
    </UserProvider>
  );
}

export default App;

